module.exports = __webpack_public_path__ + "img/owner-connect.a4e4a764.svg";